import Cookies from 'universal-cookie';
import Axios from '@services/axios';
import { onRemoveAllCookies } from '@helpers/events';

export const onLogoutHandler = async ({ navigate, onChangeSnackbarNotification, onChangeLoader, withReload }) => {
    const cookies = new Cookies();
    const userToken = cookies.get('userToken');

    try {
        onChangeLoader({ isLoadingPage: true });

        //============================ LOGOUT REQUEST ========================

        await Axios({
            url: '/api/logout',
            method: 'POST',
            headers: { Authorization: 'Bearer ' + userToken },
        });

        //============================ REMOVE COOKIES  ========================

        onRemoveAllCookies();

        onChangeSnackbarNotification({
            status: 'success',
            title: 'Logout berhasil',
            description: 'Anda berhasil keluar',
            duration: 3,
        });

        //============================ NAVIGATE  ========================

        navigate('/login');

        onChangeLoader({ isLoadingPage: false });

        if (withReload) {
            window.location.reload();
        }
    } catch (err) {
        console.log(err);
        const errorStatus = err?.response?.status;

        if (errorStatus === 401) {
            onRemoveAllCookies();

            //============================ NAVIGATE  ========================

            navigate('/login');

            onChangeLoader({ isLoadingPage: false });

            return;
        }

        const errorMessage = err?.response?.data?.message || 'Something wrong!';

        onChangeSnackbarNotification({
            status: 'error',
            title: 'Logout gagal',
            description: errorMessage,
            duration: 5,
        });

        onChangeLoader({ isLoadingPage: false });
    }
};
